import { deserialize, object, list, serialize, primitive } from 'serializr';
import ResourceBase from './../shared/resource-base';
import Agent from './agent-model';
import ModelSchemas from './../shared/model-schema';

export default class AgentResource extends ResourceBase {
    constructor() {
        super(Agent);
        this.schema = ModelSchemas.createAgentSchema(Agent, { tcFileId: primitive() }); //todo
    }

    getAgentsSearch(token, query) {
        return new Promise((resolve, reject) => {
            this.find(token, query)
                .then(agentsJSON => {
                    let agentModels = [];
                    agentsJSON.forEach(agentJSON => {
                        agentModels.push(deserialize(this.schema, agentJSON));
                    });
                    resolve(agentModels);
                })
                .catch(reject);
        });
    }

    getFileAgents(token, coordinatorId) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/agents/findByCoordinator`)
                .set('api-key', 'Bearer ' + token)
                .query({ coordinatorId: coordinatorId })
                .then(({ body }) => {
                    resolve(body);
                })
                .catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-resource.js